export default __webpack_public_path__ + "static/media/45001_2018.985cc4a4.pdf";